import React from 'react';

// (1) application configuration & initialization
export const InitializedContextCreator = React.createContext(null);
// main user context. fires after (1)
export const MGPMainCreatedContext = React.createContext(null);

// initial context for user
export const UserContextCreator = React.createContext(null);

// main state object for modal
export const ModalContextCreator = React.createContext(null);
